import React from "react";
import { Calendar, FileText, MessageCircle, Star } from "lucide-react";

const Tile = ({ icon: Icon, label, count, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="p2-myhealth-tile"
  >
    <div className="p2-myhealth-tile-icon">
      <Icon className="p2-myhealth-tile-icon-svg" />
    </div>
    <span className="p2-myhealth-tile-label">
      {label}
    </span>
    <span className="p2-myhealth-tile-sub">
      {typeof count === "number" ? `${count} gjithsej` : ""}
    </span>
  </button>
);

export default function MyHealthTiles({
  appointmentsCount = 0,
  documentsCount = 0,
  messagesUnread = 0,
  reviewsCount = 0,
  onAppointments,
  onDocuments,
  onMessages,
  onReviews,
}) {
  return (
    <section className="p2-myhealth-tiles">
      <p className="p2-myhealth-tiles-title">
        Pëmbledhje
      </p>
      <div className="p2-myhealth-tiles-grid">
        <Tile
          icon={Calendar}
          label="Takime"
          count={appointmentsCount}
          onClick={onAppointments}
        />
        <Tile
          icon={FileText}
          label="Dokumente"
          count={documentsCount}
          onClick={onDocuments}
        />
        <Tile
          icon={MessageCircle}
          label="Mesazhe"
          count={messagesUnread}
          onClick={onMessages}
        />
        <Tile
          icon={Star}
          label="Vlerësime"
          count={reviewsCount}
          onClick={onReviews}
        />
      </div>
    </section>
  );
}
